import DevicesTableView from "pages/views/DevicesTableView";
import DeviceView from "pages/views/DeviceView";
import LandingView from "pages/views/LandingView";

import NewInspectionView from "pages/views/NewInspectionView";
import AllInspectionsView from "pages/views/AllInspectionsView";

import AllAssignmentsView from "pages/views/AllAssignmentsView";
import NewAssignmentView from "pages/views/NewAssignmentView";

import ClearwayDeviceGroupsView from "modules/clearways/views/ClearwayGroupsView/Group";
import ClearwayDeviceGroupView from "modules/clearways/views/ClearwayGroupView";
import ClearwayDeviceSubgroupsView from "modules/clearways/views/ClearwayGroupsView/Subgroup";

import ClearwaysEventsView from "modules/clearways/views/ClearwaysEventsView";
import ClearwaysEventView from "modules/clearways/views/ClearwaysEventView";
import ClearwaysEventEdit from "modules/clearways/views/ClearwaysEventEdit";
import ClearwaysEventAdd from "modules/clearways/views/ClearwaysEventAdd";

import ClearwaysSubgroupsMapView from "pages/components/Map/ClearwaysMaps/Subgroups";
import ClearwaysDevicesMapView from "pages/components/Map/ClearwaysMaps/Devices";

import AllCampaignsView from "pages/views/AllCampaignsView";
import CampaignView from "pages/views/CampaignView";

import ContentRepositoryView from "pages/views/ContentRepositoryView";

import TranslationsView from "pages/views/TranslationsView";
import SettingsView from "pages/views/SettingsView";

const pageRoutes = [
  {
    name: "Home",
    route: "/",
    component: LandingView,
    in_menu: false,
  },
  {
    name: "Overview",
    key: "overview", 
    route: "/overview",
    in_menu: true,
  },
  {
    name: "Subgroup Overview",
    key: "clearways-map", 
    route: "/overview/:group_id",
    component: ClearwaysSubgroupsMapView,
    collapse: [], // don't remove
    in_menu: false,
  },
  {
    name: "Device Overview",
    key: "clearways-map",
    route: "/overview/:group_id/:subgroup_id",
    component: ClearwaysDevicesMapView,
    collapse: [], // don't remove
    in_menu: false,
  },
  {
    name: "Devices",
    key: "devices",
    route: "/devices",
    component: DevicesTableView,
    in_menu: true
  },
  {
    name: "Device View",
    key: "devices", 
    route: "/devices/:uuid",
    component: DeviceView,
    in_menu: false
  },
  {
    name: "Media",
    key: "media", 
    route: "/media",
    component: ContentRepositoryView,
    in_menu: true
  },
  {
    name: "Settings",
    route: "/settings",
    component: SettingsView,
    in_menu: false
  },
  {
    name: "Operations",
    key: "operations",
    route: "/operations",
    component: AllInspectionsView,
    collapse: [
      // --- Inspections Submenu Section ---
      {
        name: "New Inspection",
        key: "operations-inspections:add", 
        route: "/operations/new-inspection",
        icon: "add_circle_outline",
        component: NewInspectionView,
        in_menu: true
      },
      {
        name: "View All Inspections",
        key: "operations-inspections", 
        route: "/operations/inspections",
        component: AllInspectionsView,
        in_menu: true
      },
      // --- Assignments Submenu Section ---
      {
        name: "New Assignment",
        key: "operations-assignments:add", 
        route: "/operations/assignments/:assignment_id",
        component: NewAssignmentView,
        in_menu: false
      },
      {
        name: "Active Assignments",
        key: "operations-assignments",
        route: "/operations/assignments",
        component: AllAssignmentsView,
        in_menu: true
      },
    ],
    in_menu: true
  },
  {
    name: "Campaign Manager",
    key: "campaign_manager", 
    route: "/campaign",
    component: AllCampaignsView,
    in_menu: true
  },
  {
    name: "Edit Campaign",
    key: "campaign_manager", 
    route: "/campaign/:id",
    component: CampaignView,
    in_menu: false
  },
  {
    name: "Translations",
    key: "translations", 
    route: "/translations",
    component: TranslationsView,
    in_menu: true
  },
  {
    name: "Clearways",
    key: "clearways",
    route: "/clearways",
    component: ClearwaysEventsView,
    collapse: [
      // --- Groups Submenu Section ---
      {
        name: "View All Groups",
        key: "clearways-groups",
        route: "/clearways/groups",
        component: ClearwayDeviceGroupsView,
        in_menu: true,
      },
      {
        name: "View All Group's Subgroups",
        key: "clearways-groups",
        route: "/clearways/groups/:group_id/subgroups",
        component: ClearwayDeviceSubgroupsView,
        in_menu: false,
      },
      {
        name: "Selected Group",
        key: "clearways-groups",
        route: "/clearways/groups/:group_id",
        component: ClearwayDeviceGroupView,
        in_menu: false,
      },
      // --- Events Submenu Section ---
      {
        name: "View All Events",
        key: "clearways-calendar",
        route: "/clearways/events",
        component: ClearwaysEventsView,
        in_menu: true,
      },
      {
        name: "Selected Event",
        key: "clearways-calendar",
        route: "/clearways/events/:event_id",
        component: ClearwaysEventView,
        in_menu: false,
      },
      {
        name: "Selected Event Edit",
        key: "clearways-calendar:edit", 
        route: "/clearways/events/:event_id/edit",
        component: ClearwaysEventEdit,
        in_menu: false,
      },
      {
        name: "Add Event",
        key: "clearways-calendar:add",
        route: "/clearways/event",
        component: ClearwaysEventAdd,
        in_menu: false,
      },
    ],
    in_menu: true
  },
];

export default pageRoutes;